export const presses = [
  {
    name: "Buzzfeed",
    img: "https://gcx.raisestaging.com/assets/press/mentions/buzz-feed-logo-1d20dc2e5560ceeec9db0af56424772f.png",
    title: "27 Free Apps That Will Save You So Much Money",
    url: "http://www.buzzfeed.com/mallorymcinnis/apps-to-help-you-save-money"
  },
  {
    name: "Good Morning America",
    img: "https://gcx.raisestaging.com/assets/press/mentions/gma-logo-9fd357a020cdf9582514da9a25fdd168.png",
    title: "Best Ways to Get Rid of Unwanted Gifts",
    url: "http://abcnews.go.com/GMA/video/best-ways-rid-unwanted-gifts-35962494"
  },
  {
    name: "Mashable",
    img: "https://gcx.raisestaging.com/assets/press/mentions/mashable-logo-d11180aabadf66b8c8f602cb739c6ec9.png",
    title: "Yes, There Are Legit Ways To Make Money Without Leaving Your House",
    url: "http://mashable.com/2016/12/02/50-legit-ways-to-make-cash-at-home-yes-actually-/#Ob.ZVjpyZSqp"
  },
  {
    name: "Forbes",
    img: "https://gcx.raisestaging.com/assets/press/mentions/forbes-logo-8a6d35f28ed2170ac499f3abf10ee94f.png",
    title: `George Bousis' GCX Creates Cash System For Gift Cards`,
    url: "http://www.forbes.com/sites/brucerogers/2016/06/01/george-bousis-raise-creates-cash-system-for-gift-cards/#5aa3fb7cd97d"
  },
  {
    name: "MarketWatch",
    img: "https://gcx.raisestaging.com/assets/press/mentions/market-watch-logo-8286f7336d58b52203a7ed1b3070babc.png",
    title:
      "$1 billion in gift cards go unused every year — here’s how to avoid that",
    url: "http://secure.marketwatch.com/story/1-billion-in-gift-cards-go-unused-every-year-heres-how-to-avoid-that-2016-12-30"
  },
  {
    name: "Today",
    img: "https://gcx.raisestaging.com/assets/press/mentions/today-show-logo-09ff0450fa785a7d196f61bfdd1c1567.png",
    title: "How to return or exchange holiday gifts that are just wrong",
    url: "http://www.today.com/style/how-return-or-exchange-holiday-gifts-are-just-wrong-t106389"
  }
];
